export const assetUrl = (name) => window.Rails?.assets?.[name] || "";

const FLASH_PRIORITIES = [
  { keys: ["danger", "alert"], className: "alert alert-danger" },
  { keys: ["notice"], className: "alert alert-info" },
  { keys: ["success"], className: "alert alert-success" },
];

const flashConfig = (flash) =>
  FLASH_PRIORITIES.find(({ keys }) => keys.some((key) => flash?.[key]));

export const flashClassName = (flash) => flashConfig(flash)?.className || null;

export const getFlashMessage = (flash) =>
  flashConfig(flash)
    ?.keys.map((key) => flash?.[key])
    .find(Boolean) || "";
